import { createStandaloneToast } from '@chakra-ui/react';
import { NotificationStatus } from 'enums';

const { toast } = createStandaloneToast();

function notification(
  title: string,
  message: string,
  type: NotificationStatus,
  duration?: number,
  isClosable?: boolean,
  toastId?: string,
) {
  if (toastId && toast.isActive(toastId)) return;

  toast({
    id: toastId,
    title,
    description: message,
    status: type,
    duration: duration || 3000,
    isClosable,
    containerStyle: {
      color: 'white',
      marginBottom: '20px',
    },
  });
}

export default notification;
